<template>
  <div class="Dialog tips prize-pool" v-if="isShown">
    <div class="inner">
      <i class="close" @click="close"></i>
      <div class="title">个人奖励</div>
      <p class="description">累计充值{{present.num}}{{currencyName}}必得</p>
      <div class="pool-con">
        <div class="pool-con-item">
          <img :src="present.img" alt="">
          <p>{{present.name}}</p>
        </div>
      </div>
      <div class="tips-btn">
        <div class="tips-btn-t" @click="close">{{btnText}}</div>
      </div>
      <p class="prize-pool-tips">奖品发货后，请返回游戏邮箱中领取</p>

    </div>
  </div>
</template>

<script>
import myMinin from "./mixin"
export default {
  name: "Present",
  props: ["isShown", "present", "btnText", "currencyName"],
  mixins: [myMinin]
}
</script>

<style scoped>
</style>
